/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.user.progress.rpc.UserProgressReaderChirpService
 */

export const getAllUserProgressRpc = {
  serviceName: 'com.hubspot.academy.user.progress.rpc.UserProgressReaderChirpService',
  rpcName: 'getAllUserProgress',
  auth: 'app',
  fingerprint: 'qqpBJxDvAyRqERegDRtW35D18J9lvcSv',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPlaylistProgressRpc = {
  serviceName: 'com.hubspot.academy.user.progress.rpc.UserProgressReaderChirpService',
  rpcName: 'getPlaylistProgress',
  auth: 'app',
  fingerprint: 'KcaZi7Pti_TwBtXW3jDM55D18J9lvcSv',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};